// src/blocks/icon/SVGs/calendar.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var CalendarSVG = ({
  title = "Calendar Icon",
  desc = "Calendar Icon",
  descId,
  width = 20,
  height = 18,
  ...props
}) => {
  const titleId = React.useId();
  const decriptionId = React.useId();
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 20 18",
      fill: "none",
      "aria-labelledby": titleId,
      "aria-describedby": decriptionId,
      ...props,
      children: [
        desc ? /* @__PURE__ */ jsx("desc", { id: decriptionId, children: desc }) : null,
        /* @__PURE__ */ jsx("title", { id: titleId, children: title }),
        /* @__PURE__ */ jsx("path", { d: "M13.5 2H6.5V3H13.5V2Z", fill: "currentColor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M16.5 2V3H19V6.5H1V3H3.5V2H0V18H20V2H16.5ZM1 11H4.55V13.5H1V11ZM5.55 11H9.55V13.5H5.55V11ZM9.5 10H5.5V7.5H9.5V10ZM10.5 7.5H14.5V10H10.5V7.5ZM9.5 14.5V17H5.5V14.5H9.5ZM10.5 14.5H14.5V17H10.5V14.5ZM10.5 13.5V11H14.5V13.5H10.5ZM15.5 11H19V13.5H15.5V11ZM19 10H15.5V7.5H19V10ZM4.55 7.5V10H1V7.5H4.55ZM1 14.5H4.55V17H1V14.5ZM15.5 17V14.5H19V17H15.5Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M5.5 0H4.5V5H5.5V0Z", fill: "currentColor" }),
        /* @__PURE__ */ jsx("path", { d: "M15.5 0H14.5V5H15.5V0Z", fill: "currentColor" })
      ]
    }
  );
};
var calendar_default = CalendarSVG;

export {
  calendar_default
};
